import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { OverlayComponent } from './overlay.component';

@NgModule({
  declarations: [OverlayComponent],
  exports: [OverlayComponent],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OverlayModule {}
